import { useGetCitiesLazyQuery, useGetStatesQuery } from "generated/graphql";
import { ViaCEPResponse } from "containers/address/address";
import { useState, useEffect } from "react";

export type optionType = {
    value: string,
    label: string
};

const GetStatesOptionsFromQuery = () => {
    const { data: statesData, loading: statesLoading } = useGetStatesQuery(
        { fetchPolicy: 'cache-first' }
    );

    return { statesData, statesLoading };
}

export const UseStatesOptions = () => {
    const [statesOptions, setStateOptions] = useState<Array<optionType>>();

    const { statesData, statesLoading } = GetStatesOptionsFromQuery();

    useEffect(() => {
        if (statesData && statesData.states) {
            setStateOptions(
                statesData.states.map(state => (
                    {
                        value: state.abbreviation,
                        label: state.abbreviation
                    }
                ))
            );
        }
    }, [statesData])

    return { statesOptions, statesLoading };
}

export const UseGetCitiesAndStatesOptions = (addressData: ViaCEPResponse, selectedStateId?: string) => {
    const [statesOptions, setStateOptions] = useState<Array<optionType>>([]);
    const [citiesOptions, setCitiesOptions] = useState<Array<optionType>>([]);
    const [stateSelected, setStateSelected] = useState<optionType>();
    const [citySelected, setCitySelected] = useState<optionType>();

    const { statesData, statesLoading } = GetStatesOptionsFromQuery();

    const [getCities, { data: citiesData, loading: citiesLoading }] = useGetCitiesLazyQuery({
        fetchPolicy: 'cache-and-network',
    });

    useEffect(() => {
        if (statesData && statesData.states) {
            setStateOptions(
                statesData.states.map(state => (
                    {
                        value: state.id,
                        label: `${state.name} - ${state.abbreviation}`
                    }
                ))
            );
        }
    }, [statesData])

    useEffect(() => {
        if (addressData && addressData.uf) {
            const state = statesData.states.find(s => s.abbreviation === addressData.uf);
            const { id, name, abbreviation } = state;
            setStateSelected({value: id, label: `${name} - ${abbreviation}`});
            getCities({ variables: { stateId: id } });
        } else {
            selectedStateId &&
                getCities({ variables: { stateId: selectedStateId } });
        }
    }, [addressData, selectedStateId]);

    useEffect(() => {
        citiesOptions.length > 0 &&
            setCitiesOptions([]);

        if (citiesData && citiesData.citiesByStateId) {
            setCitiesOptions(
                citiesData.citiesByStateId.map(city => (
                    {
                        value: city.id,
                        label: city.name
                    }
                ))
            );
        }
        if (addressData && addressData.localidade) {
            const city = citiesData && citiesData.citiesByStateId.find(c => c.name === addressData.localidade);
            city && setCitySelected({value: city.id, label: city.name});
        }
    }, [citiesData, addressData]);

    return { statesLoading, statesOptions, citiesLoading, citiesOptions, stateSelected, citySelected };
}

